/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import StartAuditForm from './StartAuditForm/StartAuditForm';
import StartAuditSuccess from './StartAuditSuccess/StartAuditSuccess';
import StartAuditError from './StartAuditError/StartAuditError';

import styles from '../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location?: Object,
  user?: Object,
  accountId: string,
  type: string,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class StartAuditByUsers extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, user, accountStore }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'startAudit',
        label: t('actionDrawer:User'),
        fields: [
          {
            name: 'user',
            label: t('actionDrawer:user'),
            rules: '',
            value: user,
          },
          {
            name: 'account',
            label: t('actionDrawer:account'),
            rules: '',
            value: accountStore.accountId,
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { user, account }: Object = data.values().startAudit;

        actionDrawerStore.startAuditByUsers({
          id: user.id,
          account_id: account,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'startAudit',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, user, accountId, type }: TypeProps = this.props;

    const title: string = t(`actionDrawer:Start Audit by ${type}`);

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} disableCloseButton={true} type={type} />
          <StartAuditError user={user} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} disableCloseButton={true} />
          <StartAuditSuccess user={user} response={actionDrawerStore.response} type={type} />
        </div>
      );
    }

    return (
      <div className={`${styles['action-drawer-form']} ${styles.success}`}>
        <ActionDrawerHeader title={title} disableCloseButton={true} />
        <StartAuditForm user={user} form={this.createForm()} type={type} />
      </div>
    );
  }
}
